import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { WhatsNew, WhatsNewSearchModel } from '../models/whatsNew';
import { Result } from '../models/objects';

export const getWhatsNews = (ip: string, authData: AuthDataType, user: User, model: WhatsNewSearchModel): Promise<Result<WhatsNew>> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get WhatsNews body data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/whatsnew/search`
    console.log('Get WhatsNews', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getWhatsNews ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('getWhatsNews recuperato json: ' + JSON.stringify(json));
            const rv = (json as Result<WhatsNew>);
            let result: Result<WhatsNew> = new Result<WhatsNew>();
            result.ResultList = [];
            result.ListLength = 0;
            let items: WhatsNew[] = rv.ResultList;
            console.log('GetWhatsNew recuperate: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getWhatsNews error:', error);
            throw error;
        });
}


export const getWhatsNew = (ip: string, authData: AuthDataType, user: User, id: number): Promise<WhatsNew> => {
        
    console.log('Get WhatsNew id: ', + id);
    const url = `${GetConfiguration().api_url}/whatsNew/${id}`
    console.log('Get WhatsNew', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`getWhatsNew ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('getWhatsNew recuperata json: ' + JSON.stringify(json));
            const rv = (json as WhatsNew);
            console.log('getWhatsNew recuperata whatsNew: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('getWhatsNews error:', error);
            throw error;
        });
}

export const updateWhatsNew = (ip: string, authData: AuthDataType, user: User, model: WhatsNew): Promise<WhatsNew> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Update WhatsNew con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/whatsNew`
    console.log('Update WhatsNew', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`updateWhatsNew ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('updateWhatsNew recuperata json: ' + JSON.stringify(json));
            const rv = (json as WhatsNew);
            console.log('updateWhatsNew recuperata whatsNew: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('updateWhatsNews error:', error);
            throw error;
        });
}

export const closeWhatsNew = (ip: string, authData: AuthDataType, user: User, id: number): Promise<WhatsNew> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    const url = `${GetConfiguration().api_url}/whatsNew/close/${id}`
    console.log('Close WhatsNew', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`closeWhatsNew ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('closeWhatsNew recuperata json: ' + JSON.stringify(json));
            const rv = (json as WhatsNew);
            console.log('closeWhatsNew whatsNew: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('closeWhatsNews error:', error);
            throw error;
        });
}

export const openWhatsNew = (ip: string, authData: AuthDataType, user: User, id: number): Promise<WhatsNew> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    const url = `${GetConfiguration().api_url}/whatsNew/open/${id}`
    console.log('Open WhatsNew', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`open WhatsNew ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('open WhatsNew recuperata json: ' + JSON.stringify(json));
            const rv = (json as WhatsNew);
            console.log('open WhatsNew whatsNew: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('open WhatsNews error:', error);
            throw error;
        });
}

export const deleteWhatsNew = (ip: string, authData: AuthDataType, user: User, id: number): Promise<boolean> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    // console.log('Update WhatsNew con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/whatsNew`
    console.log('Delete WhatsNew', url);
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(id)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deleteWhatsNew ("${authData.user}") -> letti ${json.length} whatsNew`);
            console.log('deleteWhatsNew avente id: ' + id);
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deleteWhatsNews error:', error);
            throw error;
        });
}